/**
 * This will slide in a panel that is full height from the given direction
 * Default is right
 */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: <explanation> */
/** biome-ignore-all lint/a11y/noStaticElementInteractions: <explanation> */
import { Icons } from '@components/Icons/Icons';
import type React from 'react';
import type { ReactElement, ReactNode, SyntheticEvent } from 'react';
import { twJoin } from 'tailwind-merge';

export function SlideInPanel({
  children,
  isOpen,
  toggleState,
  scrollable = true,
  from = 'right',
  displayCloseX = true,
  testId,
}: {
  children: ReactNode;
  isOpen: boolean;
  toggleState: React.Dispatch<React.SetStateAction<boolean>>;
  scrollable?: boolean;
  from?: string;
  displayCloseX?: boolean;
  testId?: string;
}): ReactElement {
  const scrollStyle = scrollable ? 'overflow-y-scoll' : 'overflow-y-hidden';

  const close = (e: SyntheticEvent) => {
    toggleState(false);
    e.stopPropagation();
  };

  const clickedContent = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      data-open={isOpen}
      data-from={from}
      className="slideInPanel fixed top-0 z-3 h-dvh w-screen bg-grey-transparent data-[open=true]:visible data-[open=false]:invisible data-[open=false]:animate-[fade-out_0.3s_forwards] data-[open=true]:animate-[fade-in_0.3s_forwards]"
      onClick={close}
      data-testid={testId}
    >
      <div
        data-from={from}
        data-open={isOpen}
        className={twJoin(
          scrollStyle,
          "absolute m-0 flex h-full w-screen max-w-[500px] flex-col gap-3 overflow-x-hidden bg-white data-[from='left']:left-0 data-[from='right']:right-0 data-[from='left']:data-[open=false]:animate-[fadeOutToLeft_0.3s_forwards] data-[from='left']:data-[open=true]:animate-[fadeInFromLeft_0.3s_forwards] data-[from='right']:data-[open=false]:animate-[fadeOutToRight_0.3s_forwards] data-[from='right']:data-[open=true]:animate-[fadeInFromRight_0.3s_forwards] dark:bg-black"
        )}
        onClick={clickedContent}
      >
        {displayCloseX && (
          <button
            type="button"
            onClick={close}
            className="opacity-50 absolute right-2.5 top-2.5 border-none bg-black dark:bg-white z-2 rounded-full font-secondary text-4xl text-white dark:text-black hover:cursor-pointer hover:text-orange hover:no-underline focus:cursor-pointer focus:text-orange focus:no-underline"
          >
            <Icons.Close />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
